export const DealerWiseTopBuyRptConstants = {
    GETALL_REQUEST: 'DEALER_GETALL_REQUEST',
    GETALL_SUCCESS: 'DEALER_GETALL_SUCCESS',
    GETALL_FAILURE: 'DEALER_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'DEALER_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'DEALER_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'DEALER_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'LOADING_REQUEST',

    GETDEALERS_REQUEST: 'DEALERWISE_GETDEALERS_REQUEST'// New constants for dealer fetch
}